import React from 'react'
import PropTypes from 'prop-types'

// FPCC
import getIcon from 'common/utils/getIcon'
import useLoginLogout from 'common/hooks/useLoginLogout'
import DocHead from 'components/DocHead'

function ErrorHandlerPresentation({ backHandler, status, heading, content }) {
  const { login } = useLoginLogout()
  return (
    <div
      id="ErrorHandler"
      className="min-w-screen min-h-screen bg-jade-500 flex items-center p-5 lg:p-20 overflow-hidden relative"
    >
      <DocHead titleArray={[`${status} Error`]} />
      <div className="w-full flex-1 min-h-full min-w-full rounded-lg bg-white shadow-xl p-10 lg:p-20 text-charcoal-900 relative items-center text-center">
        <h1 className="font-black text-3xl lg:text-5xl text-charcoal-900 mb-10">
          Oops! We&apos;ve found a problem...
        </h1>
        <div className="mb-10 text-charcoal-700 font-light">
          <h1 className="font-black uppercase text-3xl lg:text-5xl text-jade-700 mb-5">
            {status} {heading}
          </h1>
          <div className="text-xl text-charcoal-900">{content}</div>
        </div>
        <div className="mb-5 md:mb-10">
          {status === 401 ? (
            <button
              data-testid="login"
              type="button"
              className="btn-tertiary btn-xl"
              onClick={login}
              onKeyDown={login}
            >
              {getIcon('Login')}
              <span>Sign in</span>
            </button>
          ) : (
            <button
              data-testid="back"
              type="button"
              className="btn-tertiary btn-xl"
              onClick={() => backHandler()}
            >
              {getIcon('BackArrow')}
              <span>Go back</span>
            </button>
          )}
        </div>
        <a
          className="btn-secondary btn-sm"
          href="https://firstvoices.atlassian.net/servicedesk/customer/portal/6"
          target="_blank"
          rel="noopener noreferrer"
        >
          Report problem
        </a>
      </div>
    </div>
  )
}
// PROPTYPES
const { func, node, number, oneOfType, string } = PropTypes
ErrorHandlerPresentation.propTypes = {
  backHandler: func,
  status: oneOfType([string, number]),
  heading: string,
  content: oneOfType([string, node]),
}

export default ErrorHandlerPresentation
